import Thunk, { ThunkConfig } from 'src/thunks/index';
import questionActions from 'src/store/model/question';
import { Callback, Data, List } from 'src/interfaces/general';
import { createAsyncThunk } from '@reduxjs/toolkit';
import notification from 'src/store/ui/notification';
import { AnswerPayload, UserAnswerReturn } from 'src/thunks/module_quiz';

const question = new Thunk('questions');

export type QuestionPayload = Partial<Model.Question>;

export const fetchAllQuestions = question.fetch<
  List<Model.Question>,
  SearchParams.Question & { shouldLoading?: boolean }
>({
  onSuccess: ({ data, dispatch }) => {
    dispatch(questionActions.updateEntities(data.data));
  },
});

export const fetchQuestion = question.fetchOne<
  Data<Model.Question>,
  SearchParams.Question
>({
  onSuccess: ({ data, dispatch }) => {
    dispatch(questionActions.updateEntity(data.data));
  },
});

export type ValidateAnswer = {
  class_user_id?: string;
  answer: {
    value: string[];
  };
  id: string;
  class_topic_content_id?: string;
};

export const validateAnswer = createAsyncThunk<
  Data<Model.Question>,
  Callback<Data<Model.Question>, ValidateAnswer>,
  ThunkConfig
>(
  'validate_answer',
  async ({ id, class_topic_content_id, ...rest }, { dispatch }) => {
    try {
      const { data } = await question.post(`questions/${id}/validate`, {
        ...rest,
      });

      await dispatch(
        fetchAllQuestions({
          class_user_id: rest.class_user_id,
          class_topic_content_id,
          shouldLoading: false,
        }),
      );
      return data;
    } catch (error: any) {
      dispatch(
        notification.on({
          type: 'error',
          message:
            error.response?.data?.message ||
            'An error occurred when validate answer',
        }),
      );
    }
  },
);

export const validatePitStop = question.create<
  List<Omit<Model.Question, 'user_answer'> & { user_answer: UserAnswerReturn }>,
  AnswerPayload
>('questions/validate', {
  onSuccess: ({ dispatch, data }) => {
    const dataWithNoSequence: Model.Question[] = (data.data || []).map((d) => {
      // @ts-ignore
      delete d.sequence;
      return {
        ...d,
        user_answer: {
          value: d.user_answer.value,
        },
      };
    });
    dispatch(questionActions.updateEntities(dataWithNoSequence));
  },
});

export type RetryPayload = {
  class_user_id: string;
  class_topic_content_id?: string;
  class_topic_id?: string;
};

export const retryPitStop = question.create<any, RetryPayload>(
  'questions/retry',
  {
    onSuccess({ args, dispatch }) {
      dispatch(
        questionActions.retry({
          class_topic_content_id: args.class_topic_content_id,
        }),
      );
    },
  },
);
